module.exports = __webpack_public_path__ + "static/media/desserts.17dc5765.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/desserts.svg
// module id = 72
// module chunks = 0